export default __webpack_public_path__ + "static/media/portfolio-madrid-4.4f80e40b.jpg";